import { handleJSON } from '@/utils/fetch-utils';
import { headers } from './index';

const { API_URL } = process.env;

export default {
  endpoints: {
    commandCenterFeatures: `${API_URL}/command-center-features/`,
    featureConfigurations: `${API_URL}/feature-configurations/`,
  },

  fetchFeatures() {
    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(this.endpoints.commandCenterFeatures, options).then(handleJSON);
  },

  fetchFeatureConfigurations() {
    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(this.endpoints.featureConfigurations, options).then(handleJSON);
  },
};
